import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../shared/Icon';

export function PinButton({
  pinned,
  label,
  onClick,
}: {
  pinned: boolean;
  label: string;
  onClick: () => void;
}) {
  const { t } = useTranslation('assistant');
  return (
    <button
      type="button"
      className={`maitre-pin${pinned ? ' is-on' : ''}`}
      aria-pressed={pinned}
      aria-label={pinned ? t('pinRemoveNamed', { label }) : t('pinKeepNamed', { label })}
      title={pinned ? t('pinRemove') : t('pinKeep')}
      onClick={event => {
        event.stopPropagation();
        onClick();
      }}
    >
      <Icon name="thumbtack" size={14} />
    </button>
  );
}
